"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rows = exports.Header = exports.Column = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

var Header = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  height: 35px;\n  width: 100%;\n  border-radius: 5px 5px 0px 0px;\n  background: #f0f0f0;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n"])));

exports.Header = Header;

var Column = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  height: 35px;\n  width: ", ";\n  padding: 10px 15px;\n  font-family: Roboto;\n  font-size: 12px;\n  color: ", ";\n  font-weight: ", ";\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  .flex {\n    display: flex;\n  }\n  .material-icons.small {\n    font-size: 18px;\n    color: #b3b3b3;\n  }\n  .center {\n    margin: auto;\n  }\n  &:nth-child(-n + 2) {\n    overflow: hidden;\n  }\n  .tooltip {\n    position: relative;\n    display: inline-block;\n  }\n\n  .tooltip .tooltiptext {\n    visibility: hidden;\n    background-color: #fff;\n    color: black;\n    text-align: center;\n    padding: 5px 0;\n    border-radius: 3px;\n\n    position: absolute;\n    z-index: 1;\n    top: -8px;\n    left: 3px;\n    font-family: Roboto;\n    font-size: 10px;\n    padding: 2px 5px;\n  }\n\n  .tooltip:hover .tooltiptext {\n    visibility: visible;\n  }\n"])), function (_ref) {
  var width = _ref.width;
  return "".concat(width, "px");
}, function (_ref2) {
  var isHeader = _ref2.isHeader;
  return isHeader ? "#262626" : "#707070";
}, function (_ref3) {
  var isHeader = _ref3.isHeader;
  return isHeader ? "600" : "500";
});

exports.Column = Column;

var Rows = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  background: ", ";\n  overflow-y: auto;\n  &:hover {\n    cursor: pointer;\n    background: #d4d1d7;\n  }\n"])), function (_ref4) {
  var index = _ref4.index;
  return index % 2 === 0 ? "#FFFFFF" : "#FAFAFA";
});

exports.Rows = Rows;